import { render, staticRenderFns } from "./PersonLregister.vue?vue&type=template&id=c2c68640&scoped=true"
import script from "./PersonLregister.vue?vue&type=script&lang=js"
export * from "./PersonLregister.vue?vue&type=script&lang=js"
import style0 from "./PersonLregister.vue?vue&type=style&index=0&id=c2c68640&prod&lang=scss&scoped=true"
import style1 from "./PersonLregister.vue?vue&type=style&index=1&id=c2c68640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c68640",
  null
  
)

export default component.exports